var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagNepal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9057 17.7393L31.9053 17.7388L31.9053 17.7393H31.9057Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9056 17.7392C31.9056 17.7391 31.9057 17.7389 31.9057 17.7387L14.3591 0.083252C13.5676 0.163939 12.793 0.302314 12.0398 0.494127C5.11862 2.25631 0 16.0001 0 16.0001C0 16.0001 22.3999 30.9898 24.9553 29.2603C25.4666 28.9143 25.9569 28.5395 26.4236 28.1383L16.0247 17.7392H31.9056Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8261 15.9999L12.2653 0.439209C5.2305 2.12152 0 8.4494 0 15.9999C0 24.8364 7.1635 31.9999 16 31.9999C19.3518 31.9999 22.4623 30.9685 25.0331 29.2068L11.8261 15.9999H27.8261Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.217 23.6244L13.2629 22.7053L14.3035 20.8129L12.1816 21.2188L11.9127 19.0752L10.4348 20.6518L8.95687 19.0752L8.68793 21.2188L6.56612 20.8128L7.60668 22.7053L5.65256 23.6244L7.60668 24.5435L6.56612 26.436L8.68806 26.0301L8.95681 28.1736L10.4348 26.5971L11.9127 28.1736L12.1816 26.0301L14.3034 26.4361L13.2629 24.5436L15.217 23.6244Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.913 8.87394L12.4918 8.2055L13.2486 6.82906L11.7053 7.12431L11.5097 5.56519L10.4348 6.71187L9.35986 5.56519L9.16423 7.12431L7.62092 6.82906L8.37779 8.2055L6.95648 8.87394L10.4348 9.56969L13.913 8.87394Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6087 8.87402C14.6087 11.1792 12.7399 13.048 10.4347 13.048C8.12955 13.048 6.2608 11.1792 6.2608 8.87402",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagNepal);
export default __webpack_public_path__ + "static/media/flag_nepal.7727daaa0d40959a0e2920427a98a1c1.svg";
export { ForwardRef as ReactComponent };